import { formatFramesAsTimecode } from 'medialoopster/formatTimecode';

import { VideoAsset } from '../../state/modules/video/types';

const formatVideoAssetTimecode = (frames: number, asset: VideoAsset): string =>
  formatFramesAsTimecode(frames, asset.fps);

export default formatVideoAssetTimecode;
